import { productsReferentialApiConnector } from 'apiConnector/products-referential';
import { ofType } from 'redux-observable';
import { EMPTY, merge } from 'rxjs';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { workspaceRecentProductVariationReceived } from 'state/workspaces/workspaces/workspace.actions';
import { isWorkspaceWithProductSelector } from 'state/workspaces/workspaces/workspaces.model';
import { httpClient } from 'utils/http/httpClient';

export function fetchRecentProductsReferentialEpic(): EpicWithThunk {
  return (
    action$,
    state$,
    {
      selectors: {
        getWorkspaceStaticTabProductValidation,
        isBatchProductValidated,
        getWorkspaceDynamicTabProductValidation,
        getWorkspaceEssentialTabProductValidation,
      },
    },
  ) => {
    const workspaceTabCreated$ = action$.pipe(
      ofType('WORKSPACE_TAB_CREATED'),
      filter(action => action.tabType !== 'import'),
    );

    const workspaceTabActivated$ = action$.pipe(
      ofType('WORKSPACE_TAB_ACTIVATED'),
      withLatestFrom(state$),
      filter(([{ workspace, tabId }, state]) => {
        switch (workspace) {
          case 'static':
            return !getWorkspaceStaticTabProductValidation(state, tabId);
          case 'newBatch':
            return !isBatchProductValidated(state, tabId);
          case 'dynamic':
            return getWorkspaceDynamicTabProductValidation(state, tabId);
          case 'essential':
            return !getWorkspaceEssentialTabProductValidation(state, tabId);
          default:
            return false;
        }
      }),
      map(([action]) => action),
    );

    return merge(workspaceTabActivated$, workspaceTabCreated$).pipe(
      filter(action => isWorkspaceWithProductSelector(action.workspace)),
      switchMap(() =>
        productsReferentialApiConnector(httpClient)
          .fetchRecentProducts()
          .pipe(
            map(productsReferential =>
              workspaceRecentProductVariationReceived({
                dynamic: productsReferential.dynamic,
                newBatch: productsReferential.batch,
                static: productsReferential.static,
                essential: productsReferential.essential,
              }),
            ),
            catchError(() => EMPTY),
          ),
      ),
    );
  };
}
